import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {UsersData} from "./users-data";
import {AdminUser} from "./admin-user";
import {UserData} from "./user-data";

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }
  getUsers() {
    return this.http.get<UsersData>(environment.apiUrl + "admin/users.json");
  }
  getUser(id: number) {
    return this.http.get<UserData>(environment.apiUrl + "admin/user/" + id + '.json');
  }
  updateUser(user: AdminUser) {
    return this.http.put<any>(environment.apiUrl + "admin/user/" + user.id + '.json', user);
  }
  deleteUser(id: number) {
    return this.http.delete<any>(environment.apiUrl + "admin/user/" + id + '.json');
  }
  createUser(user: AdminUser) {
    return this.http.post<any>(environment.apiUrl + "admin/user.json", user);
  }
  getRoles() {
    return this.http.get<any>(environment.apiUrl + "roles.json");
  }
}
